<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<!-- <Toast/> -->
				<DataTable :value="proposals" dataKey="_id" :paginator="true" :rows="25" :rowHover="true" showGridlines 
							v-model:first="currentPageFirstIndex" 
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50,100]"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} proposals" responsiveLayout="stack">
					<template #header>
						<div style="text-align: center">
							<h4 class="p-m-0">待预审核</h4>
						</div>
					</template>

					<Column header="序号" headerStyle="width: 6em; text-align: left">
						<template #body="slotProps">
							<span style="color: RGB(33,150,243)">{{currentPageFirstIndex + slotProps.index + 1}}</span>
						</template>
					</Column>
					<Column header="束流申请编号">
						<template #body="slotProps">
							{{slotProps.data.number}}
						</template>
					</Column>
					<Column header="实验名称">
						<template #body="slotProps">
							<div style="cursor:pointer" @click="$router.push({ name: 'proposalinfo', params: { id: slotProps.data._id } })">{{slotProps.data.experimentName}}</div>
						</template>
					</Column>
					<Column header="实验负责人">
						<template #body="slotProps">
							{{slotProps.data.ownerName}}
						</template>
					</Column>
					<Column header="单位">
						<template #body="slotProps">
							{{slotProps.data.ownerOrganization}}
						</template>
					</Column>
					<Column header="实验开始时间">
						<template #body="slotProps">
							{{showDateTime(slotProps.data.expectedDate)}}
						</template>
					</Column>
					<Column header="申请束流时间（小时）">
						<template #body="slotProps">
							{{slotProps.data.requestBeamTime}}
						</template>
					</Column>
					<Column header="提案提交时间">
						<template #body="slotProps">
							<div v-if="slotProps.data.submittedAt">{{showDateTime(slotProps.data.submittedAt)}}</div>
						</template>
					</Column>
					<Column header="状态" bodyStyle="text-align: center">
						<template #body="slotProps">
							<div :style="{'background-color': showProposalStatusColor(slotProps.data), 'line-height': '2em'}">
								{{ showProposalStatus(slotProps.data) }}
							</div>
						</template>
					</Column>
					<Column header="操作">
						<template #body="slotProps">
							<!-- <Button icon="pi pi-check" v-tooltip.top="'通过'" class="p-button-rounded p-button-success p-mr-2" @click="onTableAcceptClick(slotProps.data)" />
							<Button icon="pi pi-replay" v-tooltip.top="'退回'" class="p-button-rounded p-button-danger p-mr-2" @click="onTableRejectClick(slotProps.data)" /> -->
							<Button icon="fa fa-info" v-tooltip.top="'详情'" class="p-button-rounded p-button-primary p-mr-2" @click="showProposalInfo(slotProps.data)" />
							<!-- <Button icon="pi pi-file-pdf" v-tooltip.top="'生成PDF'" class="p-button-rounded p-button-help" @click="createPdf(slotProps.data)" /> -->
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="showProposalInfoDialog" :style="{width: '80%'}" header="提案信息" :modal="true" :maximizable="true">
					<ProposalData :proposal="proposal" />
					<template #footer>
						<Button label="通过" icon="pi pi-times" class="p-button-success" style="float: left" @click="onDialogAcceptClick()"/>
						<Button label="退回" icon="pi pi-times" class="p-button-warning" style="float: left" @click="onDialogRejectClick()"/>
						<Button label="关闭" icon="pi pi-times" class="p-button-primary" @click="showProposalInfoDialog = false"/>
					</template>
				</Dialog>

				<Dialog header="消息确认" v-model:visible="proposalAcceptDialogDisplay" :position="position" :style="{width: '30vw'}" :modal="true">
					<div>
						<div style="margin-bottom: 1em">
							<i class="pi pi-exclamation-circle fa-lg" style="color: limegreen; margin-right: 5px"></i>
							<span style="font-size: large; font-weight: bold; color: limegreen;">即将 "通过" 如下提案，请分配实验时间和时长。</span>
						</div>
						
						<div class="p-grid">
							<div class="p-col-12">
								<label>实验名称：</label><span>{{ proposal.experimentName }}</span>
							</div>
							<div class="p-col-12">
								<label>实验负责人：</label><span>{{ proposal.ownerName }}</span>
							</div>
							<div class="p-col-12">
								<label><span style="color: red">*</span> 开始时间：</label><Calendar v-model="assignedDate" :showTime="true" :showIcon="true" dateFormat="yy-mm-dd" />
							</div>
							<div class="p-col-12">
								<label><span style="color: red">*</span> 束流时间：</label><InputText type="text" v-model="proposal.assignedBeamTime" /><span>小时</span>
							</div>
						</div>
					</div>

					<template #footer>
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="proposalAcceptDialogDisplay=false"/>
						<Button label="通过" icon="pi pi-check" class="p-button-success" @click="acceptProposal()" />
					</template>
				</Dialog>

				<Dialog header="消息确认" v-model:visible="proposalRejectDialogDisplay" :position="position" :style="{width: '30vw'}" :modal="true">
					<div>
						<i class="pi pi-exclamation-triangle fa-lg" style="color: orange; margin-right: 5px"></i>
						<span style="font-size: large; font-weight: bold; color: orange;">确定要 "退回" 如下提案吗？</span>
						<div style="margin-top: 1em">
							<p>实验名称：{{ proposal.experimentName }}</p>
							<p>实验负责人：{{ proposal.ownerName }}</p>
							<span style="color: #007bff">审核意见（可以不填）：</span>
							<Textarea v-model="proposal.comment" :autoResize="true" rows="5" style="width: 100%" />
						</div>
					</div>

					<template #footer>
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="proposalRejectDialogDisplay=false"/>
						<Button label="退回" icon="pi pi-check" class="p-button-warning" @click="rejectProposal()" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>

</template>

<script>
import ProposalService from '../service/ProposalService';
import ProposalData from './ProposalData';
const dateFormat = require('dateformat');
const moment = require('moment');


export default {
	data() {
		return {
			proposals: null,
			deleteProposalDialog: false,
			showProposalInfoDialog: false,
			proposal: {},
			filters: {},

			proposalAcceptDialogDisplay: false,
			proposalRejectDialogDisplay: false,
			position: 'center',

			currentPageFirstIndex: 0,
		}
	},
	proposalService: null,
	created() {
		this.proposalService = new ProposalService();
	},
	mounted() {
		// Permission guard
		if(!this.isPreapprover) {
			this.$router.push({path: '/access'});
			return;
		}

		this.loadData();
	},
	methods: {
		loadData() {
			this.proposalService.findPreapproverToApprove()
			.then(data => {
				this.proposals = data;
			}).catch(error => {
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.message });
				}
			})
		},
		showProposalInfo(proposal) {
			// this.proposal = proposal;
			this.proposalService.findSingleProposal(proposal._id)
			.then(data => {
				this.proposal = data;
				if(!this.proposal.assignedDate)  this.proposal.assignedDate = new Date();
			}).catch(error => {
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.message });
				}
			});
			this.showProposalInfoDialog=true;
		},
		showProposalStatus(value) {
            return this.proposalService.showProposalStatus(value);
        },
        showProposalStatusColor(value) {
            return this.proposalService.showProposalStatusColor(value);
        },
		onTableAcceptClick(proposal) {
            this.position = 'center';
			this.proposal = proposal;
            this.proposalAcceptDialogDisplay = true;
        },
        onTableRejectClick(proposal) {
            this.position = 'center';
			this.proposal = proposal;
            this.proposalRejectDialogDisplay = true;
        },
        onDialogAcceptClick() {
            this.position = 'bottomleft';
            this.proposalAcceptDialogDisplay = true;
        },
        onDialogRejectClick() {
            this.position = 'bottomright';
            this.proposalRejectDialogDisplay = true;
        },
		acceptProposal() {
            let loader = this.$loading.show();
            this.proposalService.preapproverAccept(this.proposal)
            .then((data) => {
                this.loadData();
				this.showProposalInfoDialog = false;
				this.proposalAcceptDialogDisplay = false;
                this.$toast.add({severity: 'info', summary: '提案审核成功', detail: `实验名称: ${data.experimentName}\n审核结果: 通过`, life: 5000});
            }).catch(error => {
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            }).finally(() => {
                loader.hide();
            });
        },
        rejectProposal() {
            let loader = this.$loading.show();
            this.proposalService.preapproverReject(this.proposal)
            .then((data) => {
                this.loadData();
				this.showProposalInfoDialog = false;
				this.proposalRejectDialogDisplay = false;
                this.$toast.add({severity: 'info', summary: '提案审核成功', detail: `实验名称: ${data.experimentName}\n审核结果: 退回`, life: 5000});
            }).catch(error => {
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            }).finally(() => {
                loader.hide();
            });
        },
		createPdf(data) {
			this.proposalService.createPdf(data);
		},
		showDate(value) {
            return dateFormat(value, "yyyy-mm-dd");
        },
        showTime(value) {
            return dateFormat(value, "HH:MM");
        },
        showDateTime(value) {
            return dateFormat(value, "yyyy-mm-dd HH:MM");
        },
	},
	computed: {
        assignedDate: {
            get() {
                // return this.proposal.assignedDate ? new Date(this.proposal.assignedDate) : null;
				if(this.proposal.assignedDate) {
					let d = new Date(this.proposal.assignedDate);
					d.setMinutes(0, 0);
					return d;
				} else {
					return null;
				}
            },
            set(value) {
                this.proposal.assignedDate = moment(value).format("YYYY-MM-DD HH:mm");
            }
        },
        loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
    },
	components: {
        'ProposalData': ProposalData,
	},
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}
</style>
